import { EmptyState } from '@myhome/ui/patterns/empty-state';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_shell/reviews')({
  component: Page,
});

function Page() {
  return (
    <div className="flex flex-col gap-5">
      <h1 className="font-heading text-headline font-semibold text-navy-900">Reviews and complaints</h1>
      <EmptyState
        title="Reviews and complaints"
        description="Moderation and complaints arrive with the reviews feature."
      />
    </div>
  );
}
